(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/jackpots/assets/javascripts/fetch-jackpots.js') >= 0) return;  svs.modules.push('/components/numbergames/jackpots/assets/javascripts/fetch-jackpots.js');

'use strict';

let currencyInMillions;
let productMapping;
async function fetchJackpotsByProductDraw(draws, jupiterCallAsync) {
  if (!Array.isArray(draws)) {
    draws = [draws];
  }
  const allProductDrawIds = productMapping.getAllDrawIds();
  const jackpotsToFetch = draws.filter(draw => draw && allProductDrawIds.includes(productMapping.getProductDrawId(draw.productId)) && draw.drawNumber).map(_ref => {
    let {
      productId,
      drawNumber
    } = _ref;
    return "/draw/1/jackpot/draws?product=".concat(productMapping.getProductDrawId(productId), "&drawNumber=").concat(drawNumber);
  });
  if (!jackpotsToFetch.length) {
    throw new Error('fetchJackpotsByProductDraw: No valid draws provided to fetchJackpotsByDrawId');
  }
  let response;
  try {
    response = await Promise.all(jackpotsToFetch.map(path => jupiterCallAsync(path)));
  } catch (error) {
    throw new Error("fetchJackpotsByProductDraw: Failed to fetch jackpot for ".concat(jackpotsToFetch.join('|'), " ").concat(error));
  }
  try {
    const formatAmountMillions = amount => {
      const amountMillions = currencyInMillions(amount);
      return amountMillions.replace(',', '.') > 1 ? "".concat(amountMillions, " miljoner") : "".concat(amountMillions, " miljon");
    };
    return response.flatMap(_ref2 => {
      let {
        jackpot
      } = _ref2;
      const {
        productId,
        drawNumber,
        jackpots,
        guaranteedJackpots
      } = jackpot;
      const productName = productMapping.getProductName(productId);
      return guaranteedJackpots.map(_ref3 => {
        let {
          winset,
          windiv,
          description,
          jackpotAmountSek
        } = _ref3;
        const guaranteedJackpotAmount = jackpotAmountSek;
        const guaranteedJackpotAmountString = "alltid minst ".concat(formatAmountMillions(guaranteedJackpotAmount), " kr");
        const guaranteedJackpotAmountStringShort = "ca ".concat(currencyInMillions(guaranteedJackpotAmount), " milj kr");
        let defaultJackpot = true;
        let jackpotAmount = guaranteedJackpotAmount;
        let jackpotAmountString = guaranteedJackpotAmountString;
        let jackpotAmountStringShort = guaranteedJackpotAmountStringShort;
        const jackpot = jackpots.find(jackpot => jackpot.winset === winset && jackpot.windiv === windiv);
        if (jackpot) {
          defaultJackpot = false;
          description = jackpot.description;
          jackpotAmount = jackpot.jackpotAmount;
          jackpotAmountString = "ca ".concat(formatAmountMillions(jackpotAmount), " kr");
          jackpotAmountStringShort = "ca ".concat(currencyInMillions(jackpotAmount), " milj kr");
        }
        return {
          defaultJackpot,
          productId,
          productName,
          drawNumber,
          winset,
          windiv,
          description,
          guaranteedJackpotAmount,
          guaranteedJackpotAmountString,
          guaranteedJackpotAmountStringShort,
          jackpotAmount,
          jackpotAmountString,
          jackpotAmountStringShort
        };
      });
    });
  } catch (error) {
    throw new Error("fetchJackpotsByProductDraw: Failed to parse response from ".concat(jackpotsToFetch.join('|'), " ").concat(error));
  }
}
async function fetchJackpots(draws, jupiterCallAsync, getJackpots) {
  let jackpots;
  try {
    jackpots = await getJackpots();
  } catch (error) {
    throw new Error("fetchJackpots: Failed to fetch jackpots ".concat(error));
  }
  if (draws) {
    try {
      const productsToFetch = draws.filter(draw => !productMapping.isKeno(draw.productId) && !productMapping.isJoker(draw.productId) && !jackpots.find(jackpot => productMapping.isSameProduct(draw.productId, jackpot.productId))).map(draw => draw.productId);
      const jackpotsToFetch = Array.from(new Set(productsToFetch)).map(productId => {
        const productDraws = draws.filter(draw => productMapping.isSameProduct(draw.productId, productId)).sort((a, b) => a.drawNumber - b.drawNumber);
        return productDraws[0];
      });
      if (jackpotsToFetch.length) {
        const extraJackpots = await fetchJackpotsByProductDraw(jackpotsToFetch, jupiterCallAsync);
        jackpots = jackpots.concat(extraJackpots);
      }
    } catch (error) {
      throw new Error("fetchJackpots: Failed to fetch extra jackpots by product and draw ".concat(error));
    }
  }
  return jackpots;
}
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  const jackpotsApi = trinidadCore.components.require('content', 'shared').jackpots;
  currencyInMillions = trinidadCore.components.require('utils', 'format').api.CurrencyInMillions;
  ({
    productMapping
  } = trinidadCore.components.require('numbergames', 'product-mapping'));
  module.exports = {
    fetchJackpots: async _ref4 => {
      let {
        draws,
        req
      } = _ref4;
      const jupiterCallAsync = async path => {
        try {
          return await trinidadCore.jupiter.callAsync({
            method: 'GET',
            path,
            req
          });
        } catch (error) {
          throw new Error("".concat(error.name, ": ").concat(decodeURIComponent(error.message)));
        }
      };
      const getJackpots = async () => await jackpotsApi.getJackpots({
        req
      });
      return await fetchJackpots(draws, jupiterCallAsync, getJackpots);
    }
  };
} else {
  currencyInMillions = svs.utils.format.CurrencyInMillions;
  productMapping = svs.numbergames.productMapping;
  const jupiterCallAsync = async path => {
    const {
      response
    } = await svs.core.jupiter.callAsync({
      method: 'GET',
      path
    });
    return response;
  };
  const getJackpots = async () => await svs.content.shared.getJackpots([]);
  svs.numbergames.jackpot.fetchJackpots = async draws => await fetchJackpots(draws, jupiterCallAsync, getJackpots);
  svs.numbergames.jackpot.fetchJackpotsByProductDraw = async draws => await fetchJackpotsByProductDraw(draws, jupiterCallAsync);
}

 })(window);